// src/components/buttons/BtnGuardar.jsx
export default function BtnGuardar({
  label = "Guardar",
  isValid = true,
  saving = false,
  onClick = () => {},
  className = "",
}) {
  return (
    <button
      type="button"
      className={`btn-fil btn-wide ${className} ${
        !isValid || saving ? "opacity-60 cursor-not-allowed" : ""
      }`}
      disabled={!isValid || saving}
      onClick={onClick}
      title={
        !isValid
          ? "Complete todos los campos obligatorios"
          : saving
            ? "Procesando..."
            : label
      }
    >
      {saving ? "Procesando…" : label}
    </button>
  );
}
